import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "correlation_inv",
  "use": "correlation_inv-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"correlation_inv\"><path d=\"M12.99 15.24L17 17.58V22h2v-5.57l-4.02-2.35-1.99 1.16zm9.22-9.45L18 1.59 13.79 5.8a.996.996 0 101.41 1.41l1.8-1.8v4.01l-5 2.92-5-2.91V5.41L8.79 7.2c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41L6 1.59l-4.21 4.2A.996.996 0 103.2 7.2L5 5.41v5.16l5.02 2.93L5 16.43V22h2v-4.43l12-7V5.41l1.79 1.79c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol